import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type TypePick } from '@reconcept-platform/shared/data-access';
import { type User } from '@reconcept-platform/shared/types';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

export type UserAvatarName_User = TypePick<User, 'firstName' | 'lastName' | 'fullName'>;

@Component({
  selector: 'rcp-user-avatar-name',
  styleUrls: ['./user-avatar-name.component.scss'],
  template: `
    <rcp-user-avatar [user]="user" [size]="size"></rcp-user-avatar>
    <div
      class="user-name"
      [class.small]="size === 'small'"
      [class.medium]="size === 'medium'"
      [class.large]="size === 'large'"
    >
      <div class="title">
        {{ user?.fullName }}
      </div>
      <div class="subtitle"><ng-content></ng-content></div>
    </div>
  `,
  imports: [UserAvatarComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserAvatarNameComponent {
  @Input() user: UserAvatarName_User | undefined;

  @Input() size: 'small' | 'medium' | 'large' = 'small';
}
